import "./styles.scss";

import React from "react";
import clsx from "clsx";

const Hamburger = ({ isOpen, isLight, onMouseEnter, onClick }) => {
  return (
    <button
      className={clsx(
        "header-hamburger",
        isOpen && "header-hamburger--open",
        isLight && "header-hamburger--light"
      )}
      onMouseEnter={onMouseEnter}
      onClick={onClick}
    >
      {new Array(3).fill().map((_, index) => (
        <span key={index} />
      ))}
      <strong>{isOpen ? "Zamknij" : "Otwórz"}</strong>
    </button>
  );
};

export default Hamburger;
